import { render, staticRenderFns } from "./SurchargeLinkedServicesForm.vue?vue&type=template&id=ad6cd4c8&"
import script from "./SurchargeLinkedServicesForm.vue?vue&type=script&lang=js&"
export * from "./SurchargeLinkedServicesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports